import { InputPageElement } from '@app/common';
import InputDuration from './InputDuration/InputDuration';
import InputNumber from './InputNumber/InputNumber';
import InputRange from './InputRange/InputRange';
import InputSelect from './InputSelect/InputSelect';
import InputText from './InputText/InputText';

type Properties<T extends InputPageElement> = {
    element: T;
    value: any;
    setValue: (value: any) => void;
};

const InputElementRenderer = <T extends InputPageElement>(props: Properties<T>) => {
    const { element, value, setValue } = props;

    const getElement = () => {
        switch (element.type) {
            case 'input_text':
                return (
                    <InputText
                        data={element}
                        value={value}
                        setValue={setValue}
                    />
                );
            case 'input_number':
                return (
                    <InputNumber
                        data={element}
                        value={value}
                        setValue={setValue}
                    />
                );
            case 'input_select':
                return (
                    <InputSelect
                        data={element}
                        value={value}
                        setValue={setValue}
                    />
                );
            case 'input_range':
                return (
                    <InputRange
                        data={element}
                        value={value}
                        setValue={setValue}
                    />
                );
            case 'input_duration':
                return (
                    <InputDuration
                        data={element}
                        value={value}
                        setValue={setValue}
                    />
                );
            default: return <div>Element {props.element.type} not supported by InputElementsRenderer</div>;
        }
    };

    return (
        <>{getElement()}</>
    );
};

export default InputElementRenderer;
